// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { CombinationOut } from './combinationOut.zod.ts';
import { MatchOut } from './matchOut.zod.ts';

export const ResultsOut = zod.object({
  "calls": zod.int(),
  "combinations": zod.array(CombinationOut),
  "matches": zod.array(MatchOut),
  "near_misses": zod.array(MatchOut),
  "notice": zod.union([zod.string(),zod.null()]),
  "ranking_notes": zod.union([zod.string(),zod.null()]),
  "status": zod.enum(['complete', 'partial', 'no_match', 'over_budget']),
  "tokens": zod.int(),
  "unevaluated": zod.int()
});

export type ResultsOut = zod.input<typeof ResultsOut>;
export type ResultsOutOutput = zod.output<typeof ResultsOut>;
